import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { musicAlbums } from '@/mocks/neurobaby';

export default function AlbumBulletList() {
  const { t } = useTranslation();

  return (
    <ul className="grid w-full grid-cols-[max-content_minmax(0,1fr)] md:inline-grid md:w-auto md:grid-cols-[max-content_max-content] gap-y-1.5">
      {musicAlbums.map((album) => (
        <Fragment key={album.id}>
          <div className="flex items-center gap-2 bg-white rounded-l-xl border border-sand/60 border-r-0 pl-3 py-2.5">
            <span className="font-serif text-lg font-bold text-terracotta leading-none flex-shrink-0">
              {album.id}.
            </span>
            <span className="font-sans text-sm font-semibold text-[#5C3D2E] leading-snug whitespace-nowrap">
              {t(`music_albums.${album.id}.title`, album.title)}
            </span>
          </div>
          <div className="flex items-center bg-white rounded-r-xl border border-sand/60 border-l-0 pr-3 py-2.5">
            <span className="font-sans text-sm text-[#3D2B1F] leading-snug md:whitespace-nowrap">
              <span className="mx-1 text-terracotta">—</span>
              {t(`music_albums.${album.id}.subtitle`, album.subtitle)}
            </span>
          </div>
        </Fragment>
      ))}
    </ul>
  );
}